import type { Currency } from '../../../../prop-types/currency-types';

const ITN_LINE_ITEM_TOTAL_THRESHOLD = 2500;

type FulfillmentPlan = {
  items?: Array<{
    totalPrice: Currency;
  }>;
};

export const areLineItemsTotalOverLimit = (fulfillmentPlan: FulfillmentPlan) => {
  const { items } = fulfillmentPlan;
  if (items) {
    const total = items.reduce((t, i) => t + i.totalPrice.value, 0);
    return total > ITN_LINE_ITEM_TOTAL_THRESHOLD;
  }
  return false;
};
